import FsLightbox from 'fslightbox-react'
import React, {
  ComponentProps,
  FunctionComponent,
  useEffect,
  useState,
} from 'react'
import { createPortal } from 'react-dom'

const PuxLightbox: FunctionComponent<ComponentProps<typeof FsLightbox>> = (
  props
) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Escape widget stacking contexts without accessing document during Gatsby SSR.
  return mounted ? createPortal(<FsLightbox {...props} />, document.body) : null
}

export default PuxLightbox
